import React from 'react'
import PropTypes from 'prop-types'
import { Table } from 'reactstrap'
import styled from 'styled-components'
import moment from '../../lib/moment.js'
import get from 'lodash/get'
import { checkModifiedBy } from '../../function'
import { FONTS, COLORS } from '../../constants'

export default class CustomTable extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      id: '',
    }
    this.handleClickRow = this.handleClickRow.bind(this)
  }

  handleClickRow(e, edit_id, id) {
    this.props.handleClickEdit(id)
    this.setState({ id: edit_id })
  }

  checkTable(table, d) {
    if (table === 1) return d.company_code
    else if (table === 2) return d.department_code
    else if (table === 3) return d.division_code
    else if (table === 4) return d.emp_code
    else if (table === 5) return d.level_code
    else if (table === 6) return d.lob_code
    else if (table === 7) return d.position_code
    else if (table === 8) return d.team_code
  }

  render() {
    return (
    /* eslint no-underscore-dangle: 0 */
      <Wrapper>
        <NewTable bordered hover>
          <Header>
            <tr>
              {
                get(this.props, 'header.length') !== 0 &&
              get(this.props, 'header').map((h, key) =>
                <HeadTable>{ h }</HeadTable>
              )}
            </tr>
          </Header>
          <tbody style={ { width: '100%', display: 'block', maxHeight: 'calc(100vh - 200px)', overflowY: 'scroll' } }>
            {
              get(this.props, 'data.length') !== 0 &&
          get(this.props, 'data').map((d, key) =>

            (<tr style={ { hover: '#E5E5E5', background: (key === this.state.id && get(this.props, 'span')) ? '#E5E5E5' : '' } } onClick={ () => this.handleClickRow(this, key, d._id) }>
              <td>{ get(d, 'start_date') ? moment(get(d, 'start_date')).format('YYYY-MM-DD') : '' }</td>
              <td>{ d.company_code || d.lob_code || d.department_code || d.team_code || d.team_code || d.position_code || d.level_code || d.division_code }</td>
              <td>{ d.name }</td>
              <td>{ checkModifiedBy(d.updated_by, get(this.props, 'employeeList', [])) }</td>
            </tr>)
          )}
          </tbody>
        </NewTable>
      </Wrapper>
    )
  }
}

CustomTable.propTypes = {
  handleClickEdit: PropTypes.func.isRequired,
}

const Wrapper = styled.div`
  margin-left: 10px;
  margin-right: 10px;
`
const NewTable = styled(Table)`
  background: white;
  thead, tbody tr{
    display:table;
    width:100%;
    table-layout: fixed;
    font-family: ${FONTS.GOTHAM} !important;
    font-size: ${FONTS.SMALL_SIZE};
  } 
`
const HeadTable = styled.th`
  color: white;
  font-family: ${FONTS.GOTHAM_MEDIUM} !important;
  font-size: ${FONTS.SMALL_SIZE};
  cursor: pointer;
`
const Header = styled.thead`
  background: ${COLORS.TABLE_HEADER_COLOR};
`



// WEBPACK FOOTER //
// ./src/components/table/index.js